<template>
    <div>
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="10">
                    <rkm-form-select
                        :options="data.form.alergiaTipos"
                        :validations="validations.tipo"
                        label="Tipo"
                        show-default-option
                        text-field="descricao"
                        v-model="model.tipoId"
                        @change="model.alergia = null"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <div>
                        <rkm-form-checkbox
                            :label="false"
                            :uncheckedValue="enums.alergiaCriticidades.BAIXA"
                            :value="enums.alergiaCriticidades.ALTA"
                            v-model="model.criticidadeId"
                        >
                            Criticidade
                        </rkm-form-checkbox>
                    </div>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :searchFields="fields.alergia"
                        :repository="repositories.alergia"
                        :requestQueryStringParams="{ tipo_id: model.tipoId }"
                        :validations="validations.alergia"
                        textField="agenteSubstanciaEspecifica"
                        label="Agente / Substância específica"
                        v-model="model.alergia"
                        @select="model.tipoId = $event.tipo.id"
                        uppercase
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                color="primary"
                                @click="openAlergia"
                                title="Cadastrar alergia"
                            >
                                <rkm-icon icon="plus"></rkm-icon>
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Reações / Observações"
                        v-model="model.reacoesObservacoes"
                        :validations="validations.reacoesObservacoes"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :searchFields="fields.cid"
                        :requestQueryStringParams="autocompleteRequestParams.cid"
                        :repository="repositories.cid"
                        label="CID"
                        v-model="model.cid"
                        :text-field="c => `${formatCid(c.codigo)} - ${c.nome}`"
                        placeholder="Digite o código ou o nome do CID"
                        uppercase
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ formatCid(item.codigo) }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <modal-alergia
            @save="setAutocompleteAlergia"
            ref="ModalAlergia"
        />
    </div>
</template>

<script>
// Components.
import ModalAlergia from '@/components/cadastro/alergia/Modal'

// Mixins.
import { repository, formats } from '@/mixins'

// Enums.
import alergiaCriticidades from '@/enums/cadastro/cidadao/alergiaCriticidade'
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: { ModalAlergia },
    computed: {
        validations() {
            return {
                tipo: { required: true },
                alergia: { required: true },
                reacoesObservacoes: { min: 3, max: 100 }
            }
        },
        autocompleteRequestParams() {
            return {

                cid: {
                    sexo: this.model.sexoId
                        ? this.model.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                },
            }
        },
    },
    created() {
        this.repositories = {
            alergia: this.getConectaSusRepository('cadastro.sujeitoAtencao.alergia'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        fields: {
            alergia: [
                { key: 'agente_substancia_especifica', searchable: true },
            ],
            cid: [
                { key: 'codigo', searchable: true },
                { key: 'nome', searchable: true },
            ],
        },
        model: {
            tipoId: null,
            criticidadeId: 1,
            alergia: null,
            reacoesObservacoes: null,
            cid: null,
        },
        enums: { alergiaCriticidades, sexo }
    }),
    methods: {
        setAutocompleteAlergia(alergia) {

            this.model.tipoId = alergia.tipo.id
            this.model.alergia = alergia
        },
        setModel(model) {

            this.model = model
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (response === true) {

                    const duplicado = this.data.model.alergias.find(item => {
                        if (item.index !== this.index) {
                            return item.alergia.id === this.model.alergia.id
                        }

                        return false
                    })

                    if (duplicado) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: `Esta alergia já está cadastrada para este paciente.`
                        })
                    } else {

                        const data = {
                            index: this.index,
                            alergia: {
                                id: this.model.alergia.id,
                                tipo: this.data.form.alergiaTipos.find(t => t.id === this.model.tipoId),
                                agenteSubstanciaEspecifica: this.model.alergia.agenteSubstanciaEspecifica,
                                reacoesObservacoes: this.model.reacoesObservacoes,
                                cid: {
                                    ...this.model.cid,
                                    'codigoNome': this.model.cid
                                        ? this.model.cid.codigo + ' - ' + this.model.cid.nome
                                        : null
                                },
                                criticidade: this.data.form.alergiaCriticidades.find(c => c.id == this.model.criticidadeId)
                            }
                        }

                        if (this.data.model.alergias.length !== this.index) {
                            Object.assign(this.data.model.alergias[this.index], data)
                        } else {
                            this.data.model.alergias.push(data)
                        }

                        this.$emit('save', data)
                    }
                }
            })
        },
        openAlergia() {
            this.$refs.ModalAlergia.open()
        },
    },
    mixins: [repository, formats],
    props: {
        data: { type: Object, required: true },
        index: { type: Number, required: true },
    },
}
</script>